// extracted by mini-css-extract-plugin
module.exports = {"xs":"360","sm":"640","md":"768","lg":"1024","xl":"1280","default":"1366"};